import {
  REGISTER_USERS_REQUEST,
  REGISTER_USERS_SUCCESS,
  REGISTER_USERS_FAILURE,
} from 'store/register/registerAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const registerUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_USERS_REQUEST:
      return { ...state, loading: true };
    case REGISTER_USERS_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case REGISTER_USERS_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default registerUserReducer;
